import { createContext, Dispatch, SetStateAction, useMemo } from "react"
import { useLocalStorage } from "usehooks-ts"

import { LOCAL_STORAGE_FLOW } from "#/shared/constants"
import { Flow } from "#/shared/types"

export const FlowContext = createContext({
  flow: Flow.BITCOIN,
  setFlow: (() => {}) as Dispatch<SetStateAction<Flow>>,
  isBitcoinFlow: true,
  isEthereumFlow: false,
})

// Don't use this hook to get info about the context, use FlowContext instead
export const useCreateFlowContext = (): {
  flow: Flow
  setFlow: Dispatch<SetStateAction<Flow>>
  isBitcoinFlow: boolean
  isEthereumFlow: boolean
} => {
  const [flow, setFlow] = useLocalStorage<Flow>(
    LOCAL_STORAGE_FLOW,
    Flow.BITCOIN,
  )

  const isBitcoinFlow = useMemo(() => flow === Flow.BITCOIN, [flow])
  const isEthereumFlow = useMemo(() => flow === Flow.ETHEREUM, [flow])

  return { flow, setFlow, isBitcoinFlow, isEthereumFlow }
}
